// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import {
  setDetectedFaces,
  setCurrentFace,
  setFaceSearchResult,
  searchByImage,
  searchByImage_v1,
  getTags,
  setSearchedPerson
} from "../../actions/faceActions";
import type { ImageSearchInputModel } from "../../types/InputModels";
import FaceDetectLayout from "../../components/facesearch/FaceDetectLayout";
import ChipInput from "../../../global/components/ChipInput";

type FaceDetectPropsType = {
  faceSearch: { [key: string]: * },
  defaultFacebase: { [key: string]: * },
  actions: {
    setDetectedFaces: Function,
    setCurrentFace: Function,
    setFaceSearchResult: Function,
    searchByImage: Function,
    getTags: Function,
    setSearchedPerson: Function
  },
  setStep: Function,
  setImageError: Function
};

class FaceDetect extends Component<FaceDetectPropsType, *> {
  searchByImage = (
    form: {} | ImageSearchInputModel,
    token,
    imagenSearch: boolean
  ) => {
    if (imagenSearch) {
      //call v1
      this.props.actions.searchByImage_v1(form, token);
    } else {
      //call v2
      this.props.actions.searchByImage(form, token);
    }
  };

  render(): * {
    return (
      <FaceDetectLayout
        faceSearch={this.props.faceSearch}
        isV1Model={
          this.props.defaultFacebase && this.props.defaultFacebase.model === 4
        }
        setDetectedFaces={this.props.actions.setDetectedFaces}
        setCurrentFace={this.props.actions.setCurrentFace}
        setFaceSearchResult={this.props.actions.setFaceSearchResult}
        searchByImage={this.searchByImage}
        tagList={this.props.tagList}
        getTags={this.props.actions.getTags}
        setSearchedPerson={this.props.actions.setSearchedPerson}
        setStep={this.props.setStep}
        setImageError={this.props.setImageError}
        ChipInput={ChipInput}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  faceSearch: state.v3account.faceSearch,
  tagList: state.v3account.db.tagList,
  defaultFacebase: state.v3account.user.defaultFacebase
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      setDetectedFaces,
      setCurrentFace,
      setFaceSearchResult,
      searchByImage,
      searchByImage_v1,
      getTags,
      setSearchedPerson
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FaceDetect);
